import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { SearchBox } from 'components/molecules/SearchBox';
import { H2, Paragraph, Image } from 'components/atoms';
import { Container } from 'components/core/Page';
import './CTABlock.scss';

import SpareFootBrand from 'assets/images/psp/CTA/spareFootBrand.svg';
import Imagespace from 'assets/images/psp/CTA/imagespace.webp';

export default function CTABlock({
	handleSearch,
	theme = 'dark',
	title,
	subTitle,
}) {
	let image = theme === 'light' ? SpareFootBrand : Imagespace;
	return (
		<div className={classnames(`cta-container theme-${theme}`)}>
			<Container className="cta">
				<div className="cta-search-box">
					<H2
						className="search-box-label"
						color="black"
						size="xlarge"
						weight="ultraBold"
					>
						{title}
					</H2>
					<Paragraph
						color="black"
						className="search-box-sublabel"
					>
						{subTitle || "Make a free reservation, no credit-card required"}
					</Paragraph>
					<SearchBox
						id="psp-hero-sticky-search"
						inputLabel="Enter address, city or zip"
						handleSearch={handleSearch}
						hideOnScroll
						buttonText="Find Storage"
						pinkButton
					/>
				</div>

				<Image
					className={`cta-bg-image ${theme}`}
					src={image}
					alt="CTA image"
				/>
			</Container>
		</div>
	);
}

CTABlock.propTypes = {
	handleSearch: PropTypes.func,
	theme: PropTypes.string,
	title: PropTypes.string.isRequired,
	subTitle: PropTypes.string.isRequired,
	image: PropTypes.string.isRequired,
};
